import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {Button, styled, SxProps} from '@mui/material';
import { routes, wsWeddingRoutes } from 'app/providers/router/routes';
import { modalActions, ModalType } from 'entities/modal';
import { userSelector } from 'entities/user';
import { weddingSelector } from 'entities/wedding/model';
import { useShallowSelector } from 'shared/hooks';
import { useTranslation } from 'react-i18next';
import Key from '../../shared/assets/icon_key.svg';

type ConnectButtonProps = {
  size?: 'large' | 'small';
  sx?: SxProps;
};

const ButtonM = styled(Button)`
  padding: 12px 20px;
  font-weight: 600;
  font-size: 16px;
  margin-left: 0px;
  cursor: pointer;
  height: 43px;
  transition: all 0.3s ease;
  border: none;
  color: #2DB3F6;
  background: #fff;
  img {
    width: 30px
  }
  &:hover {
    border: none;
    img {
      color: #fff;
    }
  }
  @media (max-width: 768px) {
    padding: 8px 10px;
    margin-left: 0px;
    img {
      width: 25px
    }
  }
`;

export const ConnectButton = ({ size = 'small', sx }: ConnectButtonProps) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { id: userId } = useShallowSelector(userSelector.getUser);
  const { state } = useShallowSelector(weddingSelector.getWedding);

  const handleButtonClick = () => {
    if (!userId) {
      dispatch(
        modalActions.openModal({
          type: ModalType.ConnectWallet,
        }),
      );
    } else {
      navigate(state ? wsWeddingRoutes[state] : routes.connection.path);
    }
  };

  return (
    <ButtonM
      variant="outlined"
      onClick={handleButtonClick}
    >
       <img src={Key} alt={t('header_button_alt')}/>
    </ButtonM>
  );
};
